import { Link } from "react-router-dom";
import { ReactComponent as FacebookIcon } from "../assets/icons/facebook.svg";
import { ReactComponent as InstagramIcon } from "../assets/icons/instagram.svg";
import "../stylesheets/footer.scss";

// COMPONENT

function Footer() {
	return (
		<footer>
			<div className="left secondary-text">
				<Link to="/">
					<img src="/assets/logo.png" alt="LE PETIT BAR" />
				</Link>
				<div>
					<div>
						<Link to="/menu">La carte</Link>
						<Link to="/booking">Réserver</Link>
						<Link to="/contact">Contacter</Link>
					</div>
					<Link to="/">copyright Le Petit Bar 2025</Link>
				</div>
			</div>
			<div className="right">
				<Link to="https://www.instagram.com/lepetitbarcocktails/?hl=fr">
					<InstagramIcon />
				</Link>
				<Link to="https://www.facebook.com/LePetitBarCocktails/?locale=fr_FR">
					<FacebookIcon />
				</Link>
			</div>
		</footer>
	);
}

export default Footer;
